import Input from "../../../../Core/Fields/Floating/Input";
import Date from "../../../../Core/Fields/Floating/Date";
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
const GeneralDetails = ({ formData, errors,id }) => {
  return (
    <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                 <Input
            id="companyName"
            label="Company Name"
            style={{ height: "30px", border: errors.companyName ? "1px solid red" : "" }}
            value={formData.companyName}
            readOnly
          />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
            id="abbreviation"
            label="Abbreviation"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.abbreviation}
            readOnly
          />
                                </div>
                                <div style={{ flex: 1 }}>
                                   <Input
            id="defaultCurrency"
            label="Default Currency"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.defaultCurrency}
            readOnly
          />
                                  
                  
                                </div>
                                 
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                               <div style={{ flex: 1 }}>
                                <Input
            id="country"
            label="Country"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.country}
            readOnly
          />
                                 
                                </div>
                              
                                <div style={{ flex: 1 }}>
                                    <Input
            id="defaultHolidayList"
            label="default Holiday List"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.defaultHolidayList}
            readOnly
          />
                                   
                                </div>
                                
  <div style={{ flex: 1 }}>
                                 <Input
            id="defaultLetterHead"
            label="default Letter Head"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.defaultLetterHead}
            readOnly
          />
                                  
                                </div>
                               
                                
                  
                            </div>
                           <div style={{ display: 'flex', gap: '15px' }}>
                          
                            
 <div style={{ flex: 1 }}>
                                   <Input
            id="domain"
            label="Domain"
            style={{ height: "30px" }}
            value={formData.domain}
            readOnly
          />
                                </div>

                                 <div style={{ flex: 1 }}>
                                    <Input
            id="taxID"
            label="Tax ID"
            style={{ height: "30px" }}
            value={formData.taxID}
            readOnly
          />
                                </div>

                 <div style={{ flex: 1 }}>
{/* <Date
            id="dateOfEstablishment"
            label="Date of Establishment"
            value={formData.dateOfEstablishment}
            readOnly
          /> */}
           <Input
            id="dateOfEstablishment"
            label="Date of Establishment"
            style={{ height: "30px" }}
            value={formData.dateOfEstablishment}
            readOnly
          />
                  </div>
                                
                               
                            </div>
<div style={{ display: 'flex', gap: '15px' }}>
   
                  <div style={{ flex: 1 }}>
                                <Input
            id="defaultGSTRate"
            label="default GST Rate"
            style={{ height: "30px", border: errors.abbreviation ? "1px solid red" : "" }}
            value={formData.defaultGSTRate}
            readOnly
          />
                                  
                  <p
                    style={{
                      fontSize: "9px",
                      color: "#2C2B31",
                      marginLeft: "4px",
                    }}
                  >
                   Sales / Purchase Taxes and Charges Template will be created based on this GST Rate
                  </p>
                                </div>
                          <div style={{ flex: 1 }}>
                               <Input
            id="parentCompany"
            label="Parent Company"
            style={{ height: "30px" }}
            value={formData.parentCompany}
            readOnly
          />

                   </div>
                    <div style={{ flex: 1 }}>
                  <label style={{height: '19px'}}></label>
                  
                   <Checkbox
                                        id="IsGroup"
                                        label="Is Group"
                                        disabled={true}
                                        checked={true}
                                        value={formData.isgroup || false}
                                    />

                </div>
                               
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    id="gstinUin"
                    label="GSTIN/UIN"
                    style={{ height: "30px", border: errors.gstinUin ? "1px solid red" : "" }}
                    value={formData.gstinUin}
                    readOnly
                  />
                </div>
                <div style={{ flex: 1 }}>

                   <Input
            id="pan"
            label="PAN"
            style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
            value={formData.pan}
            readOnly
          />
                </div>
                <div style={{ flex: 1 }}>
 <Input
            id="gstCategory"
            label="GST Category"
            style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
            value={formData.gstCategory}
            readOnly
          />
                
                </div>
              </div>
              <br/>
               <div style={{ display: 'flex', gap: '15px' }}>
                              <div style={{ flex: 1, height: '24px' }}>
                                <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Registration Details</p>
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
              <div style={{ flex: 1 }}>
                                              
                                              <Textarea
                          id="registrationDetails"
                          label="Registration Details"
                          value={formData.registrationDetails}
                          readOnly
                          style={{ border: errors.registrationDetails ? "1px solid red" : "" }}
                        />
                        <p className="m-0" style={{fontSize:'10px',paddingLeft:'3px'}} >Company registration numbers for your reference. Tax numbers etc.</p>
                     
                                              </div>
              
              
                            </div>
              
                          

                        </div>
                    </div>
                      <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Company" docname={id} />
            </div>
          </div>
        </div>
                </div>
            </div>
   
        </div>
  );
};

export default GeneralDetails;
